export const RU_RU = 'ru-RU';
